import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServerService } from '../../../service/server/server.service';
import { CrmTaskComponent } from '../../../site/crm/crm-task/crm-task.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ShopServiceComponent } from '../../../shop-service/shop-service.component';


@Component({
  selector: 'app-user-detaile2',
  templateUrl: './user-detaile2.component.html',
  styleUrls: ['./user-detaile2.component.scss']
})
export class UserDetaile2Component implements OnInit, OnDestroy {
  public username: string;
  public lang: any;
  public server: string;
  public loading = false;
  public subscription: Subscription;
  public err: string; public err_validation: boolean = false;
  public err_internet_text: string; public err_internet_validation: boolean;
  @ViewChild('myModal') myModal: any;
  @ViewChild('myModalSearch') myModalSearch: any;
  @ViewChild('modal_attachment_open') modal_attachment_open: any;
  @ViewChild('myModalRename') myModalRename: any;
  @ViewChild('modal_cate1') modal_cate1: any;


  public task_type: number; public id: number;
  public confirm_delete: boolean;
  public count_total: number; public page_number_first: number; public page_number_second: number;
  public page: number = 1;
  public pre_status: boolean; public next_status: boolean; public new_status: boolean;
  public isOnline: boolean;
  public type: number; public type_search: number;
  public tabindex1: number = 1; public tabindex2: number = 1;
  //**************************************************************
  public obj = {};
  public data = {};
  public list_record = []; public list_new_record = [];
  public list_status: any = [];
  list_items: any = [];
  //**************************************************************
  public list_load_card_meli = [];
  public list_load_personal = [];
  public list_load_attachment3 = [];
  public list_load_logo: any = [];
  public list_load_logo2: any = [];
  //**************************************************************
  public status_id: number;
  status_admin: number;
  public group: number;
  public cate1: any;
  public user: string; public user_search: string; public user_validation: boolean;
  public fname: string; public fname_validation: boolean; public fname_search: string;
  public cate: string; public cate_search: string; cate_title: string;
  public code: number;
  public sort: any;
  message: string;
  job: number; job_title: string;
  social_cellphone: string;
  recipient: number; recipient_title: string;
  uvalue: number;
  uvalue_title: string;


  public lname: string; public lname_validation: boolean; public lname_search: any;
  public father: string;
  public email: any;
  public site: any;
  public code_meli: string;
  public address: string;
  public birth_date: any;

  public cellphone: string;
  public code_post: string;
  public fix: string;
  public fax: string;
  public about: string;
  public comment: string;
  public password: string; public pass_validation: boolean;
  public repassword: any;
  public change_pass: number;
  public config: any;
  public web: any;
  public list_load_file: any;
  public list_load_file_personal: any;
  //**************************************************************
  public address_personal_img: any;
  public address_meli_img: any;
  public address_shenasnameh_img: any;

  public user_img_personal: any;
  public user_logo;
  public user_logo2;
  public user_img_meli: any;
  public user_img_attachment3: any;

  public user_brith: any;
  public list_cate1: any = [];
  user_site: any = [];

  coop: string;
  project: string;
  meter: string;
  floor: string;
  place: string;
  visit: number;
  date1_visit: string;
  title: string;
  coop_title: string;
  project_title: string;
  visit_title: string;
  unit: number; unit_title: string;

  i: number;
  result: any;
  file_i: number;
  user_info: any;
  user_id: number;
  user_user_id: number;
  type_task: number;

  constructor(public serverService: ServerService, public router: Router, public matSnackBar: MatSnackBar
    , @Inject(MAT_DIALOG_DATA) private dialog_data: any, private matDialogRef: MatDialogRef<UserDetaile2Component>
    , private dialog: MatDialog) {
    if (dialog_data) {
      this.id = dialog_data.id;
      this.i = dialog_data.i;
    }
  }



  ngOnInit() {
    this.server = this.serverService.get_server();
    this.user_info = JSON.parse(<any>localStorage.getItem('user_info'));
    this.username = this.user_info.username;
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    this.load_data();
    this.get_setting();
    this.recieve_status();
  }


  get_setting() {
    if (this.serverService.check_internet()['status'] == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 300, id: 1 }).subscribe(
      (res) => {
        if (res['status'] == 1 && res['num'] == 1) {
          this.message = res['result'][0].site_setting_comment;
          this.recieve_message(false, "", "", 2, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }







  load_data() {
    if (this.serverService.check_internet()['status'] == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.obj = { 'address': 69, 'id': this.id, 'fname': this.fname_search, 'lname': this.lname_search, 'user': this.user_search, 'code': this.code };
    this.subscription = this.serverService.post_address(this.server, 'new_address', this.obj).subscribe(
      (res) => {
        this.data = res;
        if (this.data['status'] == 1) {

          this.user = res['result'][0].user_username;
          this.user_user_id = res['result'][0].user_id;
          this.unit = res['result'][0].user_unit;
          this.unit_title = res['result'][0].unit_title;

          this.fname = res['result'][0].user_firstname;
          this.lname = res['result'][0].user_lastname;

          this.father = res['result'][0].user_fathername;
          this.email = res['result'][0].user_email;
          this.web = res['result'][0].user_web;
          this.code_meli = res['result'][0].user_code_meli;
          this.cellphone = res['result'][0].user_cellPhone;
          this.social_cellphone = res['result'][0].user_social_cellphone;
          this.fix = res['result'][0].user_phone_fix;
          this.fax = res['result'][0].user_phone_fax;
          this.comment = res['result'][0].user_comment;
          this.uvalue = res['result'][0].user_uvalue;
          this.uvalue_title = res['result'][0].user_uvalue_title;
          this.about = res['result'][0].user_about;
          this.code_post = res['result'][0].user_code_post;
          this.cate = res['result'][0].user_cate;
          this.cate_title = res['result'][0].shop_cate_title;

          this.job = res['result'][0].user_job;
          this.job_title = res['result'][0].site_job_title;
          this.address = res['result'][0].user_address;
          this.status_id = res['result'][0].user_status;
          this.status_admin = res['result'][0].user_status_admin;

          this.group = res['result'][0].user_group;
          this.cate1 = res['result'][0].user_cate1;
          this.birth_date = res['result'][0].user_brith;
          this.user_logo = res['result'][0].user_logo;
          this.user_logo2 = res['result'][0].user_logo2;
          this.sort = res['result'][0].user_sort;
          this.user_img_personal = res['result'][0].user_img_personal;
          this.user_img_meli = res['result'][0].user_img_meli;
          this.user_img_attachment3 = res['result'][0].user_img_attachment3;
          this.user_site = res['result'][0].user_site;
          this.change_pass = 2;
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }//end else
      }//end res:Response
    ) //ens dubscribe
  }//end load data

  user_load_file() {
    if (this.serverService.check_internet()['status'] == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.modal_attachment_open.open();
    this.loading = true;
    $(document).ready(function () {
      $(".dz-complete").remove();
    });
    this.subscription = this.serverService.post_address(this.server, 'user_load_file', { 'code': this.user }).subscribe(
      (res) => {
        if (res['status'] == 1) {
          this.list_load_file = [];
          for (var i = 0; i < res['num']; i++) {
            this.list_load_file.push(res['result'][i]);
          }//end for
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }//end else
      }//end res
    )
  }//end attachment_open_modal

  update() {
    if (this.serverService.check_internet()['status'] == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    //*********************  */
    this.loading = true;
    this.obj = {
      "user_id": this.user_id, 'address': 70, "id": this.id, type: 2
      , 'change_pass': this.change_pass, 'code': this.code
      , 'code_meli': this.code_meli, 'code_post': this.code_post
      , 'father': this.father, 'email': this.email, 'web': this.web
      , 'birth_date': this.birth_date
      , 'fax': this.fax
      , 'about': this.about, 'comment': this.comment
      , 'password': this.password, 'repassword': this.repassword, 'status_id': this.status_id
      , 'status_admin': this.status_admin, 'group': this.group, 'sort': this.sort
      , 'social_cellphone': this.social_cellphone
    };
    this.subscription = this.serverService.post_address(this.server, 'new_address', this.obj).subscribe(
      (res) => {
        if (res['status'] == 1) {
          res['result'][0].i = this.i;
          this.result = res['result'][0];
          this.close();
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else if (res['status'] == 4) {
          var pe_message = "شناسه کاربری نمی تواند خالی و یا تکراری باشد";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    );
  }//end insert

  open_dataile2() {
    this.dialog.open(UserDetaile2Component, {
      width: '45rem',
      height: 'auto',
      data: { id: this.id }
    })
  }


  open_detaile() {
    this.dialog.open(CrmTaskComponent, {
      width: '65rem',
      height: 'auto',
      data: { id: this.id, user_user_id: this.user_user_id, title: this.fname + this.lname, cellphone: this.cellphone }
    })
  }


  load_service(id) {
    const dialogRef = this.dialog.open(ShopServiceComponent, {
      'width': '40rem',
      'height': 'auto',
      data: { id: id }
    });
    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result) {
          if (id == 57) { this.coop = result.id; this.coop_title = result.title; }
          if (id == 58) { this.project = result.id; this.project_title = result.title; }
          if (id == 59) { this.visit = result.id; this.visit_title = result.title; }
          if (id == 24) { this.recipient = result.id; this.recipient_title = result.title; }
          if (id == 38) { this.cate = result.id; this.cate_title = result.title; }
          if (id == 44) { this.job = result.id; this.job_title = result.title; }
          if (id == 23) { this.unit = result.id; this.unit_title = result.title; }
          if (id == 60) { this.uvalue = result.id; this.uvalue_title = result.title; }

        }
      }
    )
  };


  recieve_status() {
    if (this.serverService.check_internet()['status'] == false) {
      this.err_internet_validation = true;
      this.err_internet_text = this.serverService.check_internet()['title'];
      return;
    }//end if
    else { this.err_internet_validation = false; }
    this.subscription = this.serverService.get_address(this.server, 'get_status').subscribe(
      (res) => {
        this.list_status = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_status.push(res['result'][i]);
          }//end for
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 2, 'close', pe_action);
        }
      }
    )
  }//end recieve_status



  div_select_file(inputSelect) {
    var x = <any>document.getElementById(inputSelect)
    x.click();
  }//end div_select_file

  change_input(id, uploadButton, image, type, size) {
    this.serverService.readUrl(document.getElementById(id), document.getElementById(uploadButton), image, type, size);
  }//end change_input

  upload_submit(inputSelect, whichImage, alarm, type) {
    //this.serverService.upload_submit(inputSelect,whichImage,alarm,type,this.id,2);
  }


  close() {
    this.matDialogRef.close(this.result);
  }
  //**************************************************
  recieve_message(validation, en_message, pe_message, type, en_action, pe_action) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(pe_message, pe_action, { duration: 2000 });
    }//end if
    else {
      this.matSnackBar.dismiss();
    }
  }
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}